var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-background bg-cover flex h-screen w-screen items-center justify-center login--container"},[_c('div',{staticClass:"grid w-full max-w-4xl relative"},[_c('div',{staticClass:"text-center w-full"},[(_vm.isAcceptance)?_c('img',{staticClass:"inline-block p-16 pb-40 max-w-sm",attrs:{"src":require('@/assets/acceptance-logo.png'),"alt":"Atabix demo"}}):_c('img',{staticClass:"inline-block p-16 pb-40 max-w-sm",attrs:{"src":require('@/assets/logo-splash.png'),"alt":"Atabix demo"}})]),(_vm.isLoading)?_c('Loader',{staticClass:"mt-24"}):_c('div',{staticClass:"bg-white py-32 border-gray-200 border rounded-sm text-center"},[(!_vm.isLoading)?[_c('h1',{staticClass:"text-3xl font-semibold mb-24 text-gray-900"},[_vm._v(" Herstel in Natura ")]),(_vm.error)?_c('span',{staticClass:"text-error-500 block mb-16 font-bold"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('MiForm',{staticClass:"w-full max-w-sm my-0 mx-auto",attrs:{"fields":[
            {
              type: 'email',
              key: 'email',
              placeholder: 'Email',
              disabled: false,
              value: '',
              rules: ['email'],
              appendIcon: 'mdi-at',
            },
            {
              type: 'password',
              key: 'password',
              placeholder: 'Wachtwoord',
              disabled: false,
              value: '',
              rules: ['required'],
              appendIcon: 'mdi-key',
            },
            {
              type: 'number',
              key: 'token',
              placeholder: 'MFA Token',
              disabled: false,
              value: '',
              appendIcon: 'mdi-key',
            } ],"options":{
            buttonAlignment: 'left',
            lazyValidation: true,
            buttonOptions: {
              class: 'text-center justify-center rounded-sm font-bold',
              round: false,
              flat: true,
              label: 'LOGIN',
              color: 'primary',
              colorIntensity: '500',
              font: 'Cooper LT BT',
            },
            lazyValidation: false,
            theme: 'dark',
          }},on:{"keyEnter":_vm.onClickSubmit,"submit":_vm.onClickSubmit}})]:_vm._e()],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }